/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S6_HeadingInputs */

const tr_onbilgi_s6_heading = /** @type {(inputs: Onbilgi_S6_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Abonelik Süresi ve Yenileme`)
};

const en_onbilgi_s6_heading = /** @type {(inputs: Onbilgi_S6_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Subscription Term and Renewal`)
};

const de_onbilgi_s6_heading = /** @type {(inputs: Onbilgi_S6_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Laufzeit und Verlängerung`)
};

const ru_onbilgi_s6_heading = /** @type {(inputs: Onbilgi_S6_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Срок подписки и продление`)
};

/**
* | output |
* | --- |
* | "6. Subscription Term and Renewal" |
*
* @param {Onbilgi_S6_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s6_heading = /** @type {((inputs?: Onbilgi_S6_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S6_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s6_heading(inputs)
	if (locale === "de") return de_onbilgi_s6_heading(inputs)
	if (locale === "ru") return ru_onbilgi_s6_heading(inputs)
	return tr_onbilgi_s6_heading(inputs)
});